import { useTranslator, RichTranslator } from '@bluebeam/react-i18n';
import Users from 'components/Icons/Users';
import { FeatureFlag, useFeatureFlags } from 'featureFlags';
import React from 'react';

interface Props {
  onViewTeamClicked: () => void;
}

const AdminCard: React.FC<Props> = (props: Props) => {
  const { onViewTeamClicked } = props;
  const { translate } = useTranslator(['roverDashboard']);

  return (
    <div className="w100">
      <div className="medium font-size-5 color-gray-7">
        <div className="flex items-center mb2">
          <div className="wrem-1p5 hrem-1p5 mr1 icon flex-center fill-primary-blue">
            <Users width="16px" height="15px" />
          </div>
          <div>{translate('roverDashboard:admin')}</div>
        </div>
      </div>
      <div
        className="b-radius-3 bgd-section bold font-size-7 h100"
        style={{
          height: '96px',
        }}
      >
        <div className="flex-center grow-1 h100">
          <div className="font-normal text-[16px] text-[#373D42]">
            <RichTranslator
              components={[
                // eslint-disable-next-line jsx-a11y/control-has-associated-label
                <button
                  type="button"
                  css={{ fontFamily: 'Roboto, sans-serif' }}
                  className="cursor-pointer border-none bg-transparent text-[16px] p-0 font-medium text-primary-blue hover:underline"
                  onClick={(): void => {
                    onViewTeamClicked();
                  }}
                />,
              ]}
              translationKey="roverDashboard:adminCardMsg"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminCard;
